import { Injectable } from '@angular/core';
import { HttpGeneralService } from '../../shared/shared';
import { CONFIG } from '../../shared/config';

let SecLoginsUrl = CONFIG.baseUrls.SecUserLogins;
export interface SecLogins {
    id: number;
    userId: number;
    groupId: number;
    branchId: number;
    active: number;
    groupNameAr?: string;
    groupNameEn?: string;
    branchNameAr?: string;
    branchNameEn?: string;
    status?: any;
    defaultLogId?:number;
    notificationRepeatInterval ?:number;
}

@Injectable()
export class SecLoginsService {
    constructor(private httpGeneralService: HttpGeneralService) { }

    getSecLogins(id: number) {
        return this.httpGeneralService.get(id, SecLoginsUrl);
    }

    addSecLogins(SecLogins: SecLogins) {
        return this.httpGeneralService.add<SecLogins>(SecLogins, SecLoginsUrl);
    }

    updateSecLogins(SecLogins: SecLogins) {
        return this.httpGeneralService.update<SecLogins>(SecLogins.id, SecLogins, SecLoginsUrl);
    }

    deleteSecLogins(SecLogins: SecLogins) {
        return this.httpGeneralService.delete<number>(SecLogins.id, SecLoginsUrl);
    }

}
